export const NETWORK_ERROR =
  "処理に時間がかかり、ネットワークエラーが発生しました。サーバーで処理していますので、しばらくたってから再度ご確認ください。";

const IP_RESTRICTION = "Invalid_Ip_Address";
export default IP_RESTRICTION;
